import { useQuery } from '@tanstack/react-query';
import useAPI from '~/helpers/api-new/context';
import type { SchemaFieldsResponse } from '~/helpers/api-new/modules/workflows/workflowsApi';

type UseWorkflowVersionSchemaFieldsOptions = {
  workflowToken: string;
  internalName: string;
  pathPrefix?: string;
  enabled?: boolean;
};

function useWorkflowVersionSchemaFields(options: UseWorkflowVersionSchemaFieldsOptions) {
  const {
    workflowToken,
    internalName,
    pathPrefix,
    enabled = true,
  } = options;
  const { workflows } = useAPI();

  return useQuery<SchemaFieldsResponse>({
    queryKey: [
      'workflow-version-schema-fields',
      workflowToken,
      internalName,
      pathPrefix,
    ],
    queryFn: () => workflows.versions.getSchemaFields({
      workflowToken, internalName, pathPrefix,
    }),
    enabled: Boolean(workflowToken) && Boolean(internalName) && enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export default useWorkflowVersionSchemaFields;
